/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  DeleteTeamsIdMembersMemberidMutationResponse,
  DeleteTeamsIdMembersMemberidPathParams,
  DeleteTeamsIdMembersMemberid400,
  DeleteTeamsIdMembersMemberid401,
  DeleteTeamsIdMembersMemberid403,
  DeleteTeamsIdMembersMemberid500,
} from "../types/DeleteTeamsIdMembersMemberid.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteTeamsIdMembersMemberidMutationKey = () =>
  [{ url: "/teams/:id/members/:memberId" }] as const;

export type DeleteTeamsIdMembersMemberidMutationKey = ReturnType<
  typeof deleteTeamsIdMembersMemberidMutationKey
>;

/**
 * @description Капитан может удалить любого участника кроме себя.
 * Участник может покинуть команду самостоятельно.
 * @summary Удаление участника из команды
 * {@link /teams/:id/members/:memberId}
 */
export async function deleteTeamsIdMembersMemberid(
  id: DeleteTeamsIdMembersMemberidPathParams["id"],
  memberId: DeleteTeamsIdMembersMemberidPathParams["memberId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteTeamsIdMembersMemberidMutationResponse,
    ResponseErrorConfig<
      | DeleteTeamsIdMembersMemberid400
      | DeleteTeamsIdMembersMemberid401
      | DeleteTeamsIdMembersMemberid403
      | DeleteTeamsIdMembersMemberid500
    >,
    unknown
  >({
    method: "DELETE",
    url: `/teams/${id}/members/${memberId}`,
    ...requestConfig,
  });
  return res;
}

export function deleteTeamsIdMembersMemberidMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteTeamsIdMembersMemberidMutationKey();
  return mutationOptions<
    ResponseConfig<DeleteTeamsIdMembersMemberidMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsIdMembersMemberid400
      | DeleteTeamsIdMembersMemberid401
      | DeleteTeamsIdMembersMemberid403
      | DeleteTeamsIdMembersMemberid500
    >,
    {
      id: DeleteTeamsIdMembersMemberidPathParams["id"];
      memberId: DeleteTeamsIdMembersMemberidPathParams["memberId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id, memberId }) => {
      return deleteTeamsIdMembersMemberid(id, memberId, config);
    },
  });
}

/**
 * @description Капитан может удалить любого участника кроме себя.
 * Участник может покинуть команду самостоятельно.
 * @summary Удаление участника из команды
 * {@link /teams/:id/members/:memberId}
 */
export function useDeleteTeamsIdMembersMemberid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteTeamsIdMembersMemberidMutationResponse>,
      ResponseErrorConfig<
        | DeleteTeamsIdMembersMemberid400
        | DeleteTeamsIdMembersMemberid401
        | DeleteTeamsIdMembersMemberid403
        | DeleteTeamsIdMembersMemberid500
      >,
      {
        id: DeleteTeamsIdMembersMemberidPathParams["id"];
        memberId: DeleteTeamsIdMembersMemberidPathParams["memberId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? deleteTeamsIdMembersMemberidMutationKey();

  const baseOptions = deleteTeamsIdMembersMemberidMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<DeleteTeamsIdMembersMemberidMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsIdMembersMemberid400
      | DeleteTeamsIdMembersMemberid401
      | DeleteTeamsIdMembersMemberid403
      | DeleteTeamsIdMembersMemberid500
    >,
    {
      id: DeleteTeamsIdMembersMemberidPathParams["id"];
      memberId: DeleteTeamsIdMembersMemberidPathParams["memberId"];
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<DeleteTeamsIdMembersMemberidMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsIdMembersMemberid400
      | DeleteTeamsIdMembersMemberid401
      | DeleteTeamsIdMembersMemberid403
      | DeleteTeamsIdMembersMemberid500
    >,
    {
      id: DeleteTeamsIdMembersMemberidPathParams["id"];
      memberId: DeleteTeamsIdMembersMemberidPathParams["memberId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<DeleteTeamsIdMembersMemberidMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsIdMembersMemberid400
      | DeleteTeamsIdMembersMemberid401
      | DeleteTeamsIdMembersMemberid403
      | DeleteTeamsIdMembersMemberid500
    >,
    {
      id: DeleteTeamsIdMembersMemberidPathParams["id"];
      memberId: DeleteTeamsIdMembersMemberidPathParams["memberId"];
    },
    TContext
  >;
}
